export default __webpack_public_path__ + "static/media/website.61d0913f.png";